import Axios from '~/utils/axios';
import { useQuery } from 'react-query';
import { sentryCaptureException } from '~/errors/sentry';

type DownloadBookingHistoryProps = {
   productID: string;
   lang: string;
   fileName?: string;
};
const useDownloadAttendees = ({ productID, lang, fileName }: DownloadBookingHistoryProps) => {
   const getDownloadAttendees = async () => {
      const mime = require('mime-types');
      const { data } = await Axios.get(`/hy-providers/v1/products/${productID}/export-attendees`, {
         responseType: 'blob',
         params: {
            lang,
         },
      });
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName || 'attendees-list'}.${mime.extension(data.type)}`);
      document.body.appendChild(link);
      link.click();
      link?.parentNode?.removeChild(link);
      return data;
   };

   return useQuery(['download-attendees'], getDownloadAttendees, {
      refetchOnWindowFocus: false,
      enabled: false,
      onError: (error: Error) => {
         sentryCaptureException(error, { tags: { journey: 'business' } });
      },
   });
};

export default useDownloadAttendees;
